import React, { useEffect } from 'react'
import { Outlet, useParams, useLocation, useNavigate } from 'react-router-dom'
import { useGetDossierByIdQuery } from 'actions/dossiers/queries'
import { toast } from 'react-toastify'
import BottomNavClients from 'components/BottomNavClients'
import FloatingAssistantBot from 'components/AssistantBot/FloatingAssistantBot'
import SpliTemplateScreen from 'layouts'
import { DossierRoleProvider } from 'contexts/DossierRoleContext'
import NavbarComponent from 'layouts/navbar/NavbarComponent'
import SidebarDossierComponent from 'layouts/sidebarDossierCient/SidebarDossierComponent'

const FORBIDDEN_COMMERCIAL_SECTIONS = [
  'fournisseurs',
  'depenses',
  'transactions',
  'dettes',
  'compte_paiement',
  'comptabilite',
  'fiscalite',
  'assistant-ia',
  'partage-dossier',
  'journal-activite',
  'migration-odoo',
  'pieces-comptables',
  'parametre',
  'rapprochement',
];

const DashboardAppShellClient = () => {
  const { clientID: dossier_id } = useParams();
  const { data: dossier } = useGetDossierByIdQuery({ id: dossier_id }, { skip: !dossier_id });
  const userRole = dossier?.user_role;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole === 'COMMERCIAL') {
      const isForbidden = FORBIDDEN_COMMERCIAL_SECTIONS.some((section) =>
        location.pathname.includes(`/${section}`)
      );
      if (isForbidden) {
        toast.warning("Accès restreint : votre rôle Commercial ne vous donne pas accès à cette section.");
        navigate(`/client/${dossier_id}/facturation`, { replace: true });
      }
    }
  }, [userRole, location.pathname, dossier_id, navigate]);

  return (
    <>
    <DossierRoleProvider>
      <SpliTemplateScreen>
        <NavbarComponent />
        <SidebarDossierComponent
          activeLinkColor={"#FFFFFF"}
          activeLinkBgColor={"#009688"}
          colorOnHover={"white"}
          linkColor="#111827"
          color="#111827"
        />
        <Outlet />
      </SpliTemplateScreen>
      {userRole !== 'COMMERCIAL' && <FloatingAssistantBot />}
      <BottomNavClients />
    </DossierRoleProvider>
    </>
  )
}

export default DashboardAppShellClient